/**
 * @generated SignedSource<<9682fd773d1205ae3f8eb50c075bda96>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type WidgetWeatherSize = "ONE_X_ONE" | "TWO_X_ONE";
import { FragmentRefs } from "relay-runtime";
export type WidgetWeather_widget$data = {
  readonly currentOccasion: {
    readonly " $fragmentSpreads": FragmentRefs<"WidgetWeatherCurrentPane_weatherOccasion">;
  } | null;
  readonly id: string;
  readonly occasions: ReadonlyArray<{
    readonly date: string;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetWeatherDatePaneListItem_WeatherOccasion">;
  }>;
  readonly size: WidgetWeatherSize;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetWeatherBackground_WidgetWeather">;
  readonly " $fragmentType": "WidgetWeather_widget";
};
export type WidgetWeather_widget$key = {
  readonly " $data"?: WidgetWeather_widget$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetWeather_widget">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetWeather_widget",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "size",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetWeatherBackground_WidgetWeather"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetWeatherOccasion",
      "kind": "LinkedField",
      "name": "currentOccasion",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetWeatherCurrentPane_weatherOccasion"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetWeatherOccasion",
      "kind": "LinkedField",
      "name": "occasions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "date",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetWeatherDatePaneListItem_WeatherOccasion"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetWeather",
  "abstractKey": null
};

(node as any).hash = "3cf42315f71a86e41796ad32b24393e7";

export default node;
